import React from 'react';
import './ImageGrid.css';

// Load Services
import { fetchImagesFromAPI } from '../../Services/RandomImageService'; // ajuste o caminho

const ImageGrid = () => {


const [imageArray, setImageArray] = React.useState([]);
const [imageCredits, setImageCredits] = React.useState([]);

  React.useEffect(() => {
    fetchImagesFromAPI('turismo', 8, setImageArray, setImageCredits);
  }, []);

    return (
        <div className="image-grid">
            <div className="image-column image-column1">
                <div className="image-one image-card"><img src={imageArray[5]} className="image-card-image" /></div>
                <div className="image-two image-card"><img src={imageArray[6]} className="image-card-image" /></div>
            </div>
            <div className="image-column image-column2">
                <div className="image-three image-card"><img src={imageArray[7]} className="image-card-image" /></div>
                <div className="image-four image-card"><img src={imageArray[8]} className="image-card-image" /></div>
            </div>
        </div>
    );
};

export default ImageGrid;
